exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accountDropdown{min-width:137px;margin-top:50px}.accountDropdownItem{color:black}.accountDropdownItem:hover{cursor:pointer;color:black}.accountDropdownItem:focus{outline:none}.scrollAccountList{max-height:520px;overflow-y:auto}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/Menus/AccountMenu/style.scss
// module id = 6200
// module chunks = 0